<template>
    <div class="App">
        <router-view/>
    </div>
</template>

<script>
import SnackbarMixin from "@/mixins/SnackbarMixin";
import store from '@/store/store'

const ROLE_BUYER = 'ROLE_BUYER';
const ROLE_APPROVER = 'ROLE_APPROVER';
const ROLE_ADMIN = 'ROLE_ADMIN';

export default {
    name: 'App',
    mixins: [SnackbarMixin],
    data: () => ({}),
    created() {
        // set locale
        let locale = this.$store.getters['identity/getLocale'];
        // change locale of i18n plugin
        this.$i18n.locale = locale;
        // change lang attribute of html element in DOM
        document.getElementsByTagName('html')[0].setAttribute('lang', locale);

        this.$router.beforeEach((to, from, next) => {
            // unauthenticated user
            if (to.name !== 'login' && !store.getters['identity/isAuthenticated']) {
                store.commit('identity/removeAuthInfo')
                // this.snackbarError(this.$t('snackbar.permissions_denied'));
                next({name: 'login'})
            }

            // user is already authenticated, redirect him based on his role
            if (to.name === 'login' && this.$store.getters['identity/isAuthenticated'] !== null) {
                let roles = this.$store.getters['identity/getRoles'];
                if (roles && roles.includes(ROLE_ADMIN)) {
                    this.snackbarSuccess(this.$t('snackbar.permission_denied'));
                    next({name: 'admin'});
                } else if (roles && roles.includes(ROLE_BUYER)) {
                    this.snackbarSuccess(this.$t('snackbar.already_signed_in'));
                    next({name: 'home'});
                }
            }

            // unauthenticated user try to access protected route
            if (to.name !== 'login' && this.$store.getters['identity/isAuthenticated'] === null) {
                this.snackbarError(this.$t('snackbar.identity_check_failed'));
                this.$store.commit('identity/removeAuthInfo');
                next({name: 'login'});
            }

            // check page permissions
            let permissions = to.meta.isGranted;
            let roles = this.$store.getters['identity/getRoles'];
            if (roles && roles.includes(ROLE_ADMIN)) {
                // admin
                if (!permissions.includes(ROLE_ADMIN)) {
                    // special case for homepage
                    if (to.name !== 'home') {
                        this.snackbarError(this.$t('snackbar.permissions_denied'));
                    }
                    next({name: 'admin'});
                }
            } else if (roles && (roles.includes(ROLE_BUYER) || roles.includes(ROLE_APPROVER))) {
                // buyer & approver
                if (!permissions.includes(ROLE_BUYER) && !permissions.includes(ROLE_APPROVER)) {
                    this.snackbarError(this.$t('snackbar.permissions_denied'));
                    next({name: 'home'});
                }
            }

            next();
        });

        // unauthenticated user
        if (this.$router.currentRoute.name !== 'login' && !store.getters['identity/isAuthenticated']) {
            store.commit('identity/removeAuthInfo')
            // this.snackbarError(this.$t('snackbar.permissions_denied'));
            this.$router.push({name: 'login'});
        }

        // user is already authenticated, redirect him based on his role
        if (this.$router.currentRoute.name === 'login' && this.$store.getters['identity/getApiToken'] !== null) {
            let roles = this.$store.getters['identity/getRoles'];
            if (roles && roles.includes(ROLE_ADMIN)) {
                this.snackbarSuccess(this.$t('snackbar.already_signed_in'));
                this.$router.push({name: 'admin'});
            } else if (roles && roles.includes(ROLE_BUYER)) {
                this.snackbarSuccess(this.$t('snackbar.already_signed_in'));
                this.$router.push({name: 'home'});
            }
        }

        // unauthenticated user try to access protected route
        if (this.$router.currentRoute.name !== 'login' && this.$store.getters['identity/getApiToken'] === null) {
            this.snackbarError(this.$t('snackbar.identity_check_failed'));
            this.$store.commit('identity/removeAuthInfo');
            this.$router.push({name: 'login'});
        }

        // check page permissions
        let permissions = this.$router.currentRoute.meta.isGranted;
        let roles = this.$store.getters['identity/getRoles'];
        if (roles && roles.includes(ROLE_ADMIN)) {
            // admin
            if (!permissions.includes(ROLE_ADMIN)) {
                // special case for homepage
                if (this.$router.currentRoute.name !== 'home') {
                    this.snackbarError(this.$t('snackbar.permissions_denied'));
                }
                this.$router.push({name: 'admin'});
            }
        } else if (roles && (roles.includes(ROLE_BUYER) || roles.includes(ROLE_APPROVER))) {
            // buyer & approver
            if (!permissions.includes(ROLE_BUYER) && !permissions.includes(ROLE_APPROVER)) {
                this.snackbarError(this.$t('snackbar.permissions_denied'));
                this.$router.push({name: 'home'});
            }
        }
    }
};
</script>
